import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import Navigation from "./common/Navigation";
import Header from "./common/Header";
import * as HMS from "./common/component/Index";
import { Switch, Route, withRouter } from 'react-router-dom';
import moment from 'moment';
import { LocalStorage } from './../../utils';
import action from "../../actions";
import { logoutAction, loginAction } from "../../actions/authAction";
import DEFINE, { CONFIG_LOCAL_STORAGE } from "../../constants/Define";

import './ContainerIndex.less';
import { isMobile } from 'react-device-detect';

class ContainerIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            collapsedMenuLeft: LocalStorage.get(CONFIG_LOCAL_STORAGE.MENU_COLLAPSED),
            logging: false,
        };
    }

    componentDidMount() {

        const profile = LocalStorage.get(CONFIG_LOCAL_STORAGE.PROFILE);

        this.props.refreshToken()
        // this.props.onCheckUser();
        this.setState({ profile: profile || {} })
    };

    componentWillReceiveProps(nextProps) {
        const { match } = this.props;
        const url = match.path;
        const profile = LocalStorage.get(CONFIG_LOCAL_STORAGE.PROFILE);

        if (nextProps.authLogin.user) {
            // if(nextProps.authLogin.user.roleName.toUpperCase() !== 'ADMIN'){
            //     if(!DEFINE.GENERAL.MENU_STAFF.includes(url)){
            //         this.props.history.push('/403')
            //     }
            // }
            if (Object.keys(nextProps.authLogin.user).length > 0) {
                this.setState({ profile: nextProps.authLogin.user })
            } else {
                this.setState({ profile: profile || {} })
            }
        } else {
            this.setState({ profile: profile || {} })
        }
        if (nextProps.authLogin) {
            this.setState({
                logging: nextProps.authLogin.logging,
            })
        }
    }

    toggleCollapsedMenuLeft = (i) => {
        this.setState({
            collapsedMenuLeft: !i,
        });
        LocalStorage.set(CONFIG_LOCAL_STORAGE.MENU_COLLAPSED, !i)
    };

    render() {
        const { authLogin } = this.props;
        const { collapsedMenuLeft, profile, logging } = this.state;
        const loading = logging || authLogin.logging;
        return (
            <HMS.LoadingComponent spinning={loading} size="large" style={{ textAlign: 'center', minHeight: '50vw', maxHeight: '100%' }}>
                <div id="wrapper" style={{ display: loading ? 'none' : 'block' }}>
                    <div className={`row`}>
                        <Navigation collapsedMenuLeft={collapsedMenuLeft}
                            isAdmin={profile.roleName ? profile.roleName.toUpperCase() === 'ADMIN' : false}
                            logging={loading}
                            toggleCollapsedMenuLeft={(i) => this.toggleCollapsedMenuLeft(i)}
                            menuActive={this.props.children.props.match.path}
                            dataUser={profile}
                            permissions={profile.permissions}
                            onLogoutRequest={this.props.onLogoutRequest} />
                        <div className={`hms-page-wrapper`}>
                            {/*Header*/}
                            {isMobile &&
                                <Header toggleCollapsedMenuLeft={(i) => this.toggleCollapsedMenuLeft(i)} collapsedMenuLeft={collapsedMenuLeft}
                                    onLogoutRequest={this.props.onLogoutRequest} dataUser={profile} withAvatar={isMobile} transparent={!isMobile} />
                            }
                            {/*Content*/}
                            <div className="hms-page-content">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </HMS.LoadingComponent>
        );
    }
}

const mapStateToProps = state => {
    return {
        authLogin: state.authReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCheckUser: () => {
            dispatch(action.checkUserAction())
        },
        onLogoutRequest: () => {
            dispatch(logoutAction());
        },
        onLogin: (params) => {
            dispatch(loginAction(params))
        },
        refreshToken: token => dispatch(action.refreshTokenAction(token)),
    }
};

// export default ContainerIndex;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerIndex));

